export default __webpack_public_path__ + "static/media/category.36c36b20.svg";